module.exports = __webpack_public_path__ + "img/buhuanka.0141626d.svg";